import { create } from 'zustand';

type PrivatePageStore = {
  isPrivatePage: boolean;
  setIsPrivatePage: (isPrivatePage: boolean) => void;
  isFlowPage: boolean;
  setIsFlowPage: (isFlowPage: boolean) => void;
};

export const usePrivatePageStore = create<PrivatePageStore>((set) => ({
  isPrivatePage: false,
  setIsPrivatePage: (isPrivatePage) => set({ isPrivatePage }),
  isFlowPage: false,
  setIsFlowPage: (isFlowPage) => set({ isFlowPage }),
}));
